import { Button, InputAdornment, Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import WushTextField from "../WushTextField";
import create from "../../../api/auth/orders/orderRefunds/create";
import useAlertStore from "../../../stores/useAlertStore";
import useOrderStore from "../../../stores/useOrderStore";
import { useState } from "react";

export default function OrderRefundForm({ order, afterCreate }) {
  const [ submitting, setSubmitting ] = useState();
  const { register, handleSubmit } = useForm();

  const { addOrderRefund, orderRefunds } = useOrderStore();

  const { setAlertMessage } = useAlertStore();

  const onSubmit = (values) => {
    setSubmitting(true);
    create(order.id, values, (response) => {
      addOrderRefund(response);
      setAlertMessage('Refund submitted', 'success');
      setSubmitting(false);
      afterCreate && afterCreate();
    }, () => {
      setAlertMessage('Error submitting refund', 'error');
    });
  };

  const refundableAmount = () => {
    return order.total_price_dollars - orderRefunds.reduce((acc, refund) => acc + parseFloat(refund.amount_dollars), 0);
  };

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack mb={2}>
          <Typography variant="caption">
            Max refundable amount: ${refundableAmount()}
          </Typography>
        </Stack>
        <Stack mb={2}>
          <WushTextField
            label="Amount"
            formRegistration={register('amount')}
            defaultValue={refundableAmount()}
            type="number"
            step=".01"
            inputStartAdornment={<InputAdornment position="start">$</InputAdornment>}
          />
        </Stack>
        <Stack mb={2}>
          <WushTextField
            label="Reason"
            formRegistration={register('reason')}
            multiline
          />
        </Stack>
        <Stack>
          <Button disabled={submitting} variant="contained" type="submit">
            Submit Refund
          </Button>
        </Stack>
      </form>
    </Stack>
  );
}